import { render, staticRenderFns } from "./InvoiceItems.vue?vue&type=template&id=7d4ef9a2&scoped=true&"
import script from "./InvoiceItems.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItems.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItems.vue?vue&type=style&index=0&id=7d4ef9a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ef9a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VTooltip})
